

<!-- Top right: User name and role switcher -->
<!-- Role UI moved to global header component to avoid duplication -->



<!-- Admin Dashboards (System Admin, Market Admin, BU Admin) -->
@if (currentUser && isAdminRole) {
  <app-market-admin-dashboard
    [userRoleInput]="userRole"
    [currentUserInput]="currentUser"
    (loadingEvent)="onLoadingEvent($event)" />
}

<!-- Manager Dashboard -->
@if (currentUser && isManagerRole) {
  <app-manager-dashboard
    [userRoleInput]="userRole"
    [currentUserInput]="currentUser"
    (loadingEvent)="onLoadingEvent($event)" />
}

<!-- No Role or Access Denied -->
@if (currentUser && !isAdminRole && !isManagerRole) {
  <app-access-denied />
}
